import { create } from 'zustand';

type State = {
  validateStep:
    | 'none-login'
    | 'login-info-check'
    | 'mfa-check'
    | 'password-check'
    | 'user-status-check'
    | 'approval-status-check'
    | 'consent-check'
    | 'record-last-login'
    | 'validate-all-done';
};

type Action = {
  setValidateStep: (step: State['validateStep']) => void;
};

type ValidatorStore = State & Action;

export const useValidatorStore = create<ValidatorStore>()((set) => {
  return {
    validateStep: 'none-login',

    setValidateStep: (step) => set({ validateStep: step }),
  };
});
